import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import {
  getAlgoliaDataQueryId,
  getAlgoliaDataHitsPerPage,
  getAlgoliaDataHitsTotal,
  getAlgoliaDataHitsResults,
  getAlgoliaDataPaginationTotal,
  getAlgoliaDataPaginationCurrent,
  getAlgoliaDataHitsResultsByArtworkId,
} from 'selectors/algolia2/data'
const mapStateToProps = createStructuredSelector({
  artworks: getAlgoliaDataHitsResults,
  getArtwork: (state, ownProps) => getAlgoliaDataHitsResultsByArtworkId(ownProps.artId)(state),
  hitsPerPage: getAlgoliaDataHitsPerPage,
  hitsTotal: getAlgoliaDataHitsTotal,
  currentPage: getAlgoliaDataPaginationCurrent,
  totalPages: getAlgoliaDataPaginationTotal,
  queryId: getAlgoliaDataQueryId,
})

const mapDispatchToProps = (dispatch) => ({})

export type ConnectorProps = {
  artworks: Array<Record<string, any>>
  getArtwork: Record<string, any>
  hitsPerPage: number
  hitsTotal: number
  currentPage: number
  totalPages: number
  queryId: string
}
export default connect(mapStateToProps, mapDispatchToProps)
